import { DnrRow, EstimateInfo } from './linear-plans-constants';

// Shared NumberFormatter currency props, toggled by the CAD experiment flag.
export const currencyProps = (enableCAD: boolean | string) => ({
  prefix: enableCAD ? 'CA' : '',
  currency: enableCAD ? 'CAD' : 'USD',
  locale: enableCAD ? 'en-CA' : 'en-US'
});

export const Clearance = {
  DNR: 'DNR',
  NONE: 'None',
  ABOVE_GOAL: 'Above Goal',
  BELOW_GOAL: 'Below Goal',
  AT_GOAL: 'At Goal'
} as const;
export type ClearanceType = (typeof Clearance)[keyof typeof Clearance];

interface ClearanceForRowArgs {
  dnr: DnrRow[];
  estimateInfo?: EstimateInfo;
  week: string;
  network: string;
  avail: string;
}

export const clearanceForRow = ({
  dnr,
  estimateInfo,
  week,
  network,
  avail
}: ClearanceForRowArgs): ClearanceType => {
  if (dnr.some(row => row.week === week && row.network === network && row.avail === avail)) {
    return Clearance.DNR;
  }
  if (!estimateInfo) {
    return Clearance.AT_GOAL;
  }
  if (estimateInfo.clearedSpend === 0) {
    return Clearance.NONE;
  }
  if (
    estimateInfo.clearedSpend >
    (estimateInfo.goal + estimateInfo.goal_above) * estimateInfo.orderedSpend
  ) {
    return Clearance.ABOVE_GOAL;
  }
  if (
    estimateInfo.clearedSpend <
    (estimateInfo.goal - estimateInfo.goal_below) * estimateInfo.orderedSpend
  ) {
    return Clearance.BELOW_GOAL;
  }
  return Clearance.AT_GOAL;
};

// A spot's notes are one string, e.g. "Bonus; Overpaid; Custom note;".
export const splitNotes = (notes: string): string[] =>
  notes
    .split('; ')
    .map(note => note.replace(/;$/, ''))
    .filter(note => note.length > 0);

// "; " inside a note becomes ", " so the note does not split into two on reload.
const cleanNote = (note: string): string =>
  note.trim().replace(/;$/, '').replace(/;\s+/g, ', ').trim();

export const joinNotes = (notes: readonly string[]): string =>
  [...new Set(notes.map(cleanNote).filter(note => note.length > 0))]
    .map(note => `${note};`)
    .join(' ');
